import { render } from "./PracticeTool.vue?vue&type=template&id=6659a98f&scoped=true"
import script from "./PracticeTool.vue?vue&type=script&lang=js"
export * from "./PracticeTool.vue?vue&type=script&lang=js"

import "./PracticeTool.vue?vue&type=style&index=0&id=6659a98f&scoped=true&lang=css"
import "./PracticeTool.vue?vue&type=style&index=1&id=6659a98f&scoped=true&lang=css"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6659a98f"]])

export default __exports__